import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcLocationSectorInputComponent } from './fc-location-sector-input.component';


@NgModule({
  declarations: [
    FcLocationSectorInputComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcLocationSectorInputComponent
  ]
})
export class FcLocationSectorInputModule {}
